import TLoginInvitedUserSetPassword from './index.vue';

TLoginInvitedUserSetPassword.install = app => {
  app.component(TLoginInvitedUserSetPassword.name, TLoginInvitedUserSetPassword);
};

export default TLoginInvitedUserSetPassword;
